module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"sv":{"where_is_my_student_id":"Du hittar ditt student ID i det övre högra hörnet på ditt Mecenatkort eller i brevet från Mecenat.","go-back-studentid":"Gå tillbaka"},"en":{"where_is_my_student_id":"You will find the Student ID on the top right corner on your Mecenat card. You can also find the Student ID printed on the postal mailing we sent you.","go-back-studentid":"Go back"}}')
  delete Component.options._Ctor
}
